import { createAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';
import { Phase } from '../model/phase.model';

export interface SetPhase {
    phase: Phase | null;
}

export const setPhase = createAction<ActionType, SetPhase>(
    ActionType.COACHING__CA__SET_PHASE,
);
